import React from "react";
import { Box } from "@mui/material";

import Banner from "../../components/Home/Banner";
import ReImagineSuccess from "../../components/Home/ReImagineSuccess";
import TailoredProducts from "../../components/Home/TailoredProducts";
import FastestGrowing from "../../components/Home/FastestGrowing";
import GetInTouch from "../../components/Home/GetInTouch";
import LeadingClientPartner from "../../components/Home/LeadingClientPartner";

const Dashboard = () => {
  return (
    <Box style={{ flex: 1, marginTop: 80 }}>
      <Box style={{ marginBottom: { xs: "0px", sm: "0px", md: "30px" } }}>
        <Banner />
      </Box>

      <Box>
        <ReImagineSuccess />
      </Box>

      <Box style={{ marginBottom: "0px" }}>
        <TailoredProducts />
      </Box>

      <Box style={{ marginBottom: "40px" }}>
        <FastestGrowing />
      </Box>

      <Box style={{ marginBottom: "30px" }}>
        <LeadingClientPartner />
      </Box>

      {/* <Box style={{ marginBottom: "30px" }}>
        <ScrollCards />
      </Box> */}

      <Box style={{ marginBottom: "30px" }}>
        <GetInTouch />
      </Box>
    </Box>
  );
};

export default Dashboard;
